import fetch from 'isomorphic-fetch';

import { getHeaders } from '~/genericFunctions';
import get from 'lodash/get';
import { responseReceived } from '~/lib/mobile-x';

export const fetchLoansDetails = async ({ globalData }) => {
  const { host, protocol } = window.location;
  let data;
  try {
    data = await submit({
      globalData,
      url: `${protocol}//${host}/api/journey-details?offerId=`,
    });
  } catch (err) {
    throw Error ('Error in API fetchLoansDetails');
  }
  return data;
};

const submit = async ({ globalData, url }) => {

  let offerId = get(globalData, 'offerId');
  let cis = (offerId === 'Nva_TopUp' || offerId === 'Nva_TopUp_CP' || offerId === 'TopUp_AN_MB' || offerId === 'TopUp_CP_MB')? '000000060712191' : '37334';

  let submitUrl, response;

  submitUrl = `${url}${offerId}`;
  response = await fetch(submitUrl, {
    method: 'get',
    headers: getHeaders({
      globalData,
      cis,
    }),
  });
  responseReceived(get(response, 'status'));
  if (!response.ok) {
    throw Error(response.statusText);
  }
  let data = await response.json();
  return data;
};
